// /* eslint-disable react-hooks/rules-of-hooks */
import { useEffect, useState, useMemo, useRef } from "preact/hooks";
import Notifications from "react-notify-toast";
import { Filters } from "./Filters";
import { InfoBox, Map, Pagination, VendorsData } from "/components";
import { Fragment } from "preact";
import { createPortal } from 'react-dom' 


import {
  conditionalToken,
  capitalizeFirstLetter,
  getCookie,
  getCategoryTitleWithKey,
  getFiltersFromURLParams,
  getURL,
  parseVendorsData,
  mapToggleButtonClass,
  renderToggleMapText,
  renderHeader,
  scrollIntoView,
  showFavouriteSuccess,
  horizontalScrollIntoView,
  showFavouriteFailure,
  isMobileScreen,
} from "../helpers";

import { locationCategories } from "./static-data";
import style from "./app.css";

// this is frontend
const API_HOST = "https://api.weddyplace.com/";

const VENDOR_PER_PAGE = 19;
let staticPageFetched = false;

const App = () => {
  const filterbar_container = typeof window !== "undefined" ? document.querySelector(".filterbar") : null;
  const map_container = typeof window !== "undefined" ? document.querySelector(".right") : null;
  const mapButton_container = typeof window !== "undefined" ? document.querySelector(".mapButton") : null;
  const results_container = typeof window !== "undefined" ? document.querySelector("#results") : null;

  const {
    initialCategory,
    initialCity,
    initialCapacity,
    initialBudget,
    initialLat,
    initialLng,
    initialZoom,
    initialTags,
    initialServices
  } = getFiltersFromURLParams();

  const hasInitialLocation = initialLat != undefined && initialLng != undefined
  const urlContainsCoordinates = typeof window != 'undefined' ? window.location.href.includes('lat=') && window.location.href.includes('lng=') : false;

  const isMobile = isMobileScreen();
  const [showMap, setShowMap] = useState(
    !isMobile && initialCategory === "locations",
  );

  const [filter, setFilter] = useState({
    categoryFilter: initialCategory,
    cityFilter: initialCity,
    capacityFilter: initialCapacity,
    budgetFilter: initialBudget,
    lat: initialLat,
    lng: initialLng,
    zoom: initialZoom,
    selectedTags: initialTags,
    selectedServices: initialServices
  });

  const [vendorResultsPage, setVendorResultsPage] = useState(1);
  const skipNextIdleRef = useRef(false)
  const skipNextRequestRef = useRef(0)
  const [vendorsDataLoading, setVendorsDataLoading] = useState(true);
  const [isFromPop, setIsFromPop] = useState(false);
  const [guessedLocation, setGuessedLocation] = useState({});
  const [reqParams, setReqParams] = useState("");
  const [allVendors, setAllVendors] = useState([])
  const [interestingVendors, setInterestingVendors] = useState([]);
  const [scrollBackToVendor, setScrollBackToVendor] = useState(
    (typeof window !== "undefined" &&
      window.location.href.indexOf("/search") > 0) ? location.hash.slice(1).replace('-infoWindow', '') : null
  );
  const [lastRequestMapCenter, setLastRequestMapCenter] = useState();

  const [didOneInitialAlready, setDidOneInitialAlready] = useState(false);

  const scrollBackVendorIntoView = (vendorsData) => {
    setTimeout(() => {
      const vendorToScrollTo = vendorsData.find(vendor => vendor.id == scrollBackToVendor)
      if (!vendorToScrollTo) return;
      if (!isMobile) {
        handlePinSelect(vendorToScrollTo);
      } else {
        handlePageChange(vendorToScrollTo?._page || 1, false);
        setTimeout(() => {
          const mobileTileToScrollTo = document.querySelector(`div[data-id="${scrollBackToVendor}"]`);
          if (!mobileTileToScrollTo) return;
          const headerOffset = 160;
          const mobileTilePosition = mobileTileToScrollTo.getBoundingClientRect().top;
          const tileOffsetPosition = mobileTilePosition + window.pageYOffset - headerOffset;
          document.querySelector('.left').scrollTo({
            top: tileOffsetPosition,
            behavior: "smooth"
          });
        });
      }
    }, 1);
  };

  if (!hasInitialLocation && typeof window !== "undefined" && !didOneInitialAlready) {
    setDidOneInitialAlready(true);
    
    let req = `?cat=${initialCategory ? initialCategory : "locations"}`;
    const token = getCookie("token") || "";
    const url = `${API_HOST}search${req}`;
    const fallbackUrl = `/search/${initialCategory ? initialCategory : "locations"}?lat=53&lng=13&zoom=10`;
    const fallbackFilter = { ...filter };
    fallbackFilter.lat = 53;
    fallbackFilter.lng = 13;
    fallbackFilter.zoom = 10;

    setVendorsDataLoading(true);

    // console.log('%c making a request (no initial location)', 'background: #222; color: #bada55');
    fetch(url, {
      headers: {
        "Content-Type": "application/json",
        Authorization: conditionalToken(token),
      },
    }).then((response) => {
      if (response.status !== 200) {
        console.log(`There was a problem, status code = ${response.status}`);
        window.history.replaceState({ id: "Search" }, "Search", fallbackUrl);
        setFilter({ ...fallbackFilter });
        return;
      }

      response.json().then((data) => {
        let guessedLocation = {
          loc: data?.geo?.city,
          lat: data?.geo?.ll[0],
          lng: data?.geo?.ll[1],
        };

        console.info(`Guessed location ( ${data?.geo?.country} ): ${guessedLocation.loc}, Lat: ${guessedLocation.lat}, Long: ${guessedLocation.lng}`);
        

        setGuessedLocation(guessedLocation);
        const guessedLocationUrl = `/search/${initialCategory ? initialCategory : "locations"}?loc=${guessedLocation.loc}&lat=${guessedLocation.lat}&lng=${guessedLocation.lng}&zoom=10`
        window.history.replaceState({ id: "Search" }, "Search", guessedLocationUrl);
        const updatedFilter = { ...filter };
        updatedFilter.lat = guessedLocation.lat;
        updatedFilter.lng = guessedLocation.lng;
        updatedFilter.zoom = 10;
        setFilter({ ...updatedFilter });
        setLastRequestMapCenter({
          lat: Number(updatedFilter.lat),
          lng: Number(updatedFilter.lng)
        });

        let urlAfter = getURL(false, updatedFilter);
        urlAfter = urlAfter.replace(/\?/g, "&");
        req += urlAfter;
        setReqParams(req);

        if (!window["dataLayer"]) {
          window["dataLayer"] = [];
        }
        if (window["dataLayer"]) {
          window["dataLayer"].push({ vendor_cat: filter.categoryFilter });
        }

        let parsedData = parseVendorsData(data);
        let vendorsData = parsedData.vendorsData;
        let interestingVendors = parsedData.interestingVendors;

        vendorsData.forEach((v, index) => {
          v._page = Math.ceil((index + 1) / VENDOR_PER_PAGE);
        });

        setAllVendors(vendorsData)
        setInterestingVendors(interestingVendors);
        setVendorsDataLoading(false);

        if (scrollBackToVendor) {
          scrollBackVendorIntoView(vendorsData);
        }

        setScrollBackToVendor(null);

        if (window["dataLayer"]) {
          window["dataLayer"].push({
            event: "search-result",
            params: req,
            results: vendorsData.length,
          });
        }

        if (window.mapsScriptLoaded) {
          window.reinitializeMap = true;
        }

        skipNextRequestRef.current = 1;
      });
    })
      .catch((err) => {
        console.log("Fetch error", err);
        window.history.replaceState({ id: "Search" }, "Search", fallbackUrl);
        setFilter({ ...fallbackFilter });
      })
  }

  /** Two cases that this will get called
   * 1. Navigating to a specific page. Includes back/forth, to a specific one
   * 2. Popstate, aka Navigating backwards. After updateBrowserUrl is getting called from the filter change
   * 3.
   */
  const updateBrowserUrl = (replaceInsead = false) => {
    const { categoryFilter } = filter;

    let browserUrl =
      `/search/${categoryFilter ? categoryFilter : "locations"}`;

    let urlAfter = getURL(true, filter);
    browserUrl += urlAfter;

    if (!isFromPop) {
      if (replaceInsead) {
        window.history.replaceState({ id: "Search" }, "Search", browserUrl);
      } else {
        window.history.pushState({ id: "Search" }, "Search", browserUrl);
      }
    }
  };

  const fetchVendors = () => {
    let req = `?cat=${filter.categoryFilter ? filter.categoryFilter : "locations"}`;

    let urlAfter = getURL(false, filter);
    urlAfter = urlAfter.replace(/\?/g, "&");

    req += urlAfter;

    setReqParams(req);

    let token = getCookie("token") || "";

    if (!window["dataLayer"]) {
      window["dataLayer"] = [];
    }
    if (window["dataLayer"]) {
      window["dataLayer"].push({ vendor_cat: filter.categoryFilter });
    }

    setVendorsDataLoading(true);
    let url = `${API_HOST}search${req}`;

    // console.log('%c making a request (fetchVendors)', 'background: #222; color: #bada55');
    fetch(url, {
      headers: {
        "Content-Type": "application/json",
        Authorization: conditionalToken(token),
      },
    })
      .then((response) => {
        if (response.status !== 200) {
          console.log(
            `There was a problem, status code = ${response.status}`,
          );
        }

        response.json().then((data) => {
          if (data.locationGuessed) {
            let guessedLocation = {
              loc: data.geo.city,
              lat: data.geo.ll[0],
              lng: data.geo.ll[1],
            };
            setGuessedLocation(guessedLocation);
          } else {
          }

          setLastRequestMapCenter({
            lat: Number(data.geo.ll[0]),
            lng: Number(data.geo.ll[1]),
          });

          let parsedData = parseVendorsData(data);
          let vendorsData = parsedData.vendorsData;
          let interestingVendors = parsedData.interestingVendors;

          vendorsData.forEach((v, index) => {
            v._page = Math.ceil((index + 1) / VENDOR_PER_PAGE);
          });

          setAllVendors(vendorsData)
          setInterestingVendors(interestingVendors);
          setVendorResultsPage(1);
          setVendorsDataLoading(false);

          if (scrollBackToVendor) {
            scrollBackVendorIntoView(vendorsData);
          }

          setScrollBackToVendor(null);

          if (window["dataLayer"]) {
            window["dataLayer"].push({
              event: "search-result",
              params: req,
              results: vendorsData.length,
            });
          }
        });
      })
      .catch((err) => {
        console.log("Fetch error", err);
      });

    if (isFromPop) {
      setIsFromPop(false);
    }
  };

  if (hasInitialLocation && !urlContainsCoordinates && !staticPageFetched) {
    fetchVendors();
    staticPageFetched = true;
    if (isFromPop) {
      setIsFromPop(false);
    }
    skipNextRequestRef.current = 2;
  }

  const pageVendors = useMemo(() => {
    // hopefully allVendors is sorted by isPremium before this pagination
    return allVendors.slice((vendorResultsPage - 1) * VENDOR_PER_PAGE, vendorResultsPage * VENDOR_PER_PAGE)
  }, [allVendors, vendorResultsPage]);

  useEffect(() => {
    if (typeof window !== "undefined") {
      let appContainer = document.querySelector(".parentContainer");
      if (appContainer) {
        if (showMap) {
          appContainer.classList.remove("noMap");
          appContainer.classList.add("hasMap");
        } else {
          appContainer.classList.add("noMap");
          appContainer.classList.remove("hasMap");
        }
      }
    }
    setTimeout(() => {
      const event = new CustomEvent("toggleImageResize");
      document.dispatchEvent(event);
    }, 850);
  }, [showMap]);

  const scrollTop = () => {
    let leftContainer = document.querySelector(".left");

    if (leftContainer) {
      leftContainer.scrollTop = 0;
    }
  };

  const handlePinSelect = (vendor) => {
    handlePageChange(vendor?._page || 1, false);

    if (!isMobile) {
      setTimeout(() => {
        scrollIntoView(vendor);
      });
    } else {
      setTimeout(() => {
        horizontalScrollIntoView(vendor);
      });
    }
  };

  const fetchVendorsIfOutOfRadius = () => {
    let shouldFetchVendors = false;
    if (typeof window.globalMap !== 'undefined' && lastRequestMapCenter) {
      const {
        initialLat,
        initialLng,
      } = getFiltersFromURLParams();

      const newMapCenter = {
        lat: Number(initialLat),
        lng: Number(initialLng)
      }

      const distanceBetweenCenters = (google?.maps?.geometry?.spherical?.computeDistanceBetween?.(lastRequestMapCenter, newMapCenter) || 0) / 1000;
      if (distanceBetweenCenters > 75) {
        shouldFetchVendors = true;
      }
    } else {
      shouldFetchVendors = true;
    }

    if (shouldFetchVendors) {
      let req = `?cat=${filter.categoryFilter ? filter.categoryFilter : "locations"}`;

      let urlAfter = getURL(false, filter);
      urlAfter = urlAfter.replace(/\?/g, "&");

      req += urlAfter;

      setReqParams(req);

      let token = getCookie("token") || "";

      if (!window["dataLayer"]) {
        window["dataLayer"] = [];
      }
      if (window["dataLayer"]) {
        window["dataLayer"].push({ vendor_cat: filter.categoryFilter });
      }

      setVendorsDataLoading(true);
      let url = `${API_HOST}search${req}`;
      // todo: do a more sophisticated initial searchRadius guess - taking zoom level/window size into account
      let searchRadius = 120000;

      url += `&radius=${searchRadius}`;

      // console.log('%c making a request (fetchVendorsIfOutOfRadius)', 'background: #222; color: #bada55');
      fetch(url, {
        headers: {
          "Content-Type": "application/json",
          Authorization: conditionalToken(token),
        },
      })
        .then((response) => {
          if (response.status !== 200) {
            console.log(
              `There was a problem, status code = ${response.status}`,
            );
          }

          response.json().then((data) => {
            if (data.locationGuessed) {
              let guessedLocation = {
                loc: data.geo.city,
                lat: data.geo.ll[0],
                lng: data.geo.ll[1],
              };
              setGuessedLocation(guessedLocation);
            } else {
            }

            setLastRequestMapCenter({
              lat: Number(data.geo.ll[0]),
              lng: Number(data.geo.ll[1]),
            });

            let parsedData = parseVendorsData(data);
            let vendorsData = parsedData.vendorsData;
            let interestingVendors = parsedData.interestingVendors;

            vendorsData.forEach((v, index) => {
              v._page = Math.ceil((index + 1) / VENDOR_PER_PAGE);
            });

            setAllVendors(vendorsData)
            setInterestingVendors(interestingVendors);
            setVendorResultsPage(1);
            setVendorsDataLoading(false);

            if (scrollBackToVendor) {
              scrollBackVendorIntoView(vendorsData);
            }

            setScrollBackToVendor(null);

            if (window["dataLayer"]) {
              window["dataLayer"].push({
                event: "search-result",
                params: req,
                results: vendorsData.length,
              });
            }
          });
        })
        .catch((err) => {
          console.log("Fetch error", err);
        });
    } else if (isFromPop) {
      const {
        initialLat,
        initialLng,
        initialZoom,
      } = getFiltersFromURLParams();

      window.globalMap.setZoom(Number(initialZoom) || 10)
      window.globalMap
        .setCenter({
          lat: Number(initialLat) || 53,
          lng: Number(initialLng) || 13,
        });
      
      setIsFromPop(false);
    }
  };

  const usePrevious = (value) => {
    const ref = useRef();
    useEffect(() => {
      ref.current = value;
    }, [value]);

    return ref.current;
  };

  const previousLat = usePrevious(filter.lat);
  const previousLng = usePrevious(filter.lng);
  const previousZoom = usePrevious(filter.zoom);
  const previousCategoryFilter = usePrevious(filter.categoryFilter);
  const previousCityFilter = usePrevious(filter.cityFilter);
  const previousCapacityFilter = usePrevious(filter.capacityFilter);
  const previousBudgetFilter = usePrevious(filter.budgetFilter);
  const previousSelectedServices = usePrevious(filter.selectedServices);

  let isFirstLoad = Boolean(previousLat === undefined) // This is required to stop the URL from changing on static pages. Boolean just in case ¯\ (ツ)/¯

  // main useEffect
  useEffect(() => {
    if (hasInitialLocation) {
      if (!skipNextRequestRef.current) {
        if (previousLat != filter.lat || previousLng != filter.lng || previousZoom != filter.zoom) {
          !isFirstLoad && updateBrowserUrl();
          isFirstLoad = false;
          fetchVendorsIfOutOfRadius();
        } else if (previousCategoryFilter != filter.categoryFilter || previousCityFilter != filter.cityFilter || previousCapacityFilter != filter.capacityFilter || previousBudgetFilter != filter.budgetFilter || previousSelectedServices != filter.selectedServices) {
          updateBrowserUrl();
          fetchVendors();
        }
      } else {
        skipNextRequestRef.current = skipNextRequestRef.current - 1;
      }
    }
  }, [
    filter.lat,
    filter.lng,
    filter.zoom,
    filter.categoryFilter,
    filter.cityFilter,
    filter.capacityFilter,
    filter.budgetFilter,
    filter.selectedTags,
    filter.selectedServices,
  ]);

  const handleBack = (e) => {
    e.preventDefault(); // required to avoid memory leak issue with setting state?
    setDidOneInitialAlready(false);
    setIsFromPop(true);
    skipNextIdleRef.current = true;

    const {
      initialCategory,
      initialCity,
      initialCapacity,
      initialBudget,
      initialLat,
      initialLng,
      initialZoom,
      initialServices
    } = getFiltersFromURLParams();

    setFilter({
      categoryFilter: initialCategory,
      cityFilter: initialCity,
      capacityFilter: initialCapacity,
      budgetFilter: initialBudget,
      lat: initialLat,
      lng: initialLng,
      zoom: initialZoom,
      selectedTags: initialTags,
      selectedServices: initialServices
    });
  };

  useEffect(() => {
    window.addEventListener("popstate", handleBack);
    return () => {
      document.removeEventListener("popstate", handleBack);
    };
  }, []);

  const handlePageChange = (page, scrollToTop = true) => {
    setVendorResultsPage(page);
    if (scrollToTop) {
      scrollTop();
    }
  };

  const getTotalCount = () => allVendors.length

  const handleStayOnLandingPage = () => {
    //This means were navigating away from a "seo landing page" to "normal search"... i.e category or city has changed.
    let el = document.querySelector(".seoContainer");
    if (el) {
      el.remove();
    }
  };

  const handleFavouriteVendor = (vendor) => {
    let token = getCookie("token") || "";

    if (!token) {
      const event = new CustomEvent("signup-open");
      document.dispatchEvent(event);
      return;
    }

    let bodyData = { vendorId: vendor.id };

    // console.log('%c making a request (fav)', 'background: #222; color: #bada55');
    fetch(`${API_HOST}swipe_likeVendor`, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${JSON.parse(token)}`,
      },
      body: JSON.stringify(bodyData),
    })
      .then((response) => {
        response.json().then(() => {
          if (response.status == 200) {
            const allVendorsIndex = allVendors.findIndex(v => v.id === vendor.id);
            if (allVendorsIndex) {
              allVendors[allVendorsIndex].favourited = true;
              setAllVendors([...allVendors]);
            } else {
              const interestingVendorsIndex = interestingVendors.findIndex(v => v.id === vendor.id);
              if (interestingVendorsIndex) {
                interestingVendors[interestingVendorsIndex].favourited = true;
                setInterestingVendors([...interestingVendors]);
              }
            }
            if (window["dataLayer"])
              window["dataLayer"].push({
                event: "vendor-faved",
                vendorId: window.vendorId,
              });
            showFavouriteSuccess();
          } else if (response.status === 401) {
            const event = new CustomEvent("signup-open");
            document.dispatchEvent(event);
            return;
          } else {
            showFavouriteFailure();
          }
        });
      })
      .catch((error) => {
        console.error("Error:", error);
      });
  };

  const renderVendorResults = () => {
    return (
      <VendorsData
        loading={vendorsDataLoading}
        pageVendors={pageVendors}
        totalVendorsCount={allVendors.length}
        interestingVendors={interestingVendors}
        showMap={showMap}
        onFavouriteVendor={handleFavouriteVendor}
      />
    );
  };

  const conditionalRenderInfoBox = () => {
    const isMainLocation = locationCategories.find(
      (loc) => loc.title === filter.cityFilter,
    );
    if (!isMainLocation || !filter.cityFilter || filter.cityFilter.length === 0) return null;

    return (
      <InfoBox
        class={style.infoBox}
        city={capitalizeFirstLetter(filter.cityFilter)}
        category={getCategoryTitleWithKey(filter.categoryFilter || "locations")}
        guessedLocation={guessedLocation}
      />
    );
  };

  const navigateToSearchAll = () => {
    window.location.href = "https://www.weddyplace.com/search/";
  };

  const getResultCount = () => {
    if (vendorsDataLoading) return null;

    return `(${allVendors.length} Ergebnisse)`;
  };

  const handleMapIdle = (mapCoordinates) => {
    if (skipNextIdleRef.current) {
      skipNextIdleRef.current = false;
      return;
    }

    // preserve current filter props and change only lat and lng
    const updatedFilter = { ...filter };
    updatedFilter.lat = mapCoordinates.lat;
    updatedFilter.lng = mapCoordinates.lng;
    updatedFilter.zoom = mapCoordinates.zoom;

    setFilter(updatedFilter);
  };

  return (
    <div>
      {typeof window !== "undefined" && createPortal(
        <Fragment>
          <div class={style.header}>
            <div class={style.backIcon} onClick={navigateToSearchAll} />
            <div class={style.searchDiv}>
              <h2 class={style.searchHeader}>
                <span class={style.searchHeaderTitle}>
                  {renderHeader(
                    getCategoryTitleWithKey(filter.categoryFilter),
                    filter.cityFilter,
                  )}
                </span>

                <span class={style.resultsCount}>
                  {getResultCount()}
                </span>
              </h2>
            </div>

            <div class={style.filterIcon} />
          </div>

          <Filters
            filters={filter}
            reqParams={reqParams}
            onSetFilter={(newFilters) => setFilter(newFilters)}
            onStayOnLandingPage={(stayOnLandingPage) =>
              handleStayOnLandingPage(stayOnLandingPage)
            }
          />
        </Fragment>,
        filterbar_container,
      )}

      {typeof window !== "undefined" && createPortal(
        <>
          {conditionalRenderInfoBox()}
          <div>{renderVendorResults()}</div>
          <Pagination
            currentPage={vendorResultsPage}
            totalCount={getTotalCount()}
            pageSize={VENDOR_PER_PAGE}
            siblingCount={isMobile ? 0 : 1}
            onPageChange={(page) => {
              handlePageChange(page);
            }}
          />
        </>,
        results_container,
      )}

      {typeof window !== "undefined" && hasInitialLocation &&
        createPortal(
          <Map
            initialCoordinates={{ lat: filter.lat ? filter.lat : guessedLocation.lat, lng: filter.lng ? filter.lng : guessedLocation.lng, zoom: filter.zoom }}
            vendors={allVendors}
            onIdle={(mapCoordinates) => handleMapIdle(mapCoordinates)}
            onSelectPin={handlePinSelect}
            onFavouriteVendor={handleFavouriteVendor}
          />,
          map_container
        )}
      {typeof window !== "undefined" && !hasInitialLocation &&
        createPortal(
          <div>
            map not loaded
          </div>,
          map_container
        )}

      {typeof window !== "undefined" &&
        createPortal(
          <button
            class={mapToggleButtonClass(showMap)}
            onClick={() => {
              let left = document.querySelector(".left");
              if (left) {
                left.scrollTop = 0;
              }
              setShowMap(!showMap);
            }}
          >
            <div class={showMap ? style.listIcon : style.mapIcon} />
            {renderToggleMapText(showMap)}
          </button>,
          mapButton_container,
        )}
      <Notifications />
    </div>
  );
};

export default App;
